"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import { Layers3, ListChecks, LineChart, BarChart3, ShieldAlert, FlaskConical, CalendarDays, Radar } from "lucide-react";

const moreItems = [
  { href: "/foreign-radar", label: "외국인레이더", Icon: Radar },
  { href: "/risk", label: "리스크", Icon: ShieldAlert },
  { href: "/calendar", label: "캘린더", Icon: CalendarDays },
  { href: "/backtest", label: "백테스트", Icon: FlaskConical },
  { href: "/sector-performance", label: "그룹현황", Icon: BarChart3 },
  { href: "/presets", label: "차수설정", Icon: ListChecks },
  { href: "/group-mapping", label: "그룹매핑", Icon: Layers3 },
  { href: "/etf", label: "ETF(kr)", Icon: LineChart },
  { href: "/etf-us", label: "ETF(us)", Icon: LineChart },
];

interface MoreSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MoreSheet({ open, onOpenChange }: MoreSheetProps) {
  const pathname = usePathname();

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
      title="더보기"
      description="추가 메뉴"
      maxHeight="60svh"
    >
      <SheetContent className="pt-1">
        <ul className="grid grid-cols-2 gap-2">
          {moreItems.map((item) => {
            const isActive = pathname === item.href;
            const { Icon } = item;
            return (
              <li key={item.href}>
                <Link
                  href={item.href}
                  onClick={() => onOpenChange(false)}
                  className={cn(
                    "flex flex-col items-center justify-center gap-1.5 rounded-lg p-4",
                    "border border-black/[0.06] transition-colors",
                    isActive
                      ? "bg-[#0071e3]/10 border-[#0071e3]/30 text-neutral-900"
                      : "bg-black/[0.03] text-black/80 active:bg-black/[0.06]"
                  )}
                >
                  <Icon className="h-5 w-5" strokeWidth={isActive ? 2.2 : 1.7} />
                  <span className="text-xs tracking-[-0.12px]">{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </SheetContent>
    </Sheet>
  );
}

/** "더보기" 메뉴에 포함된 경로 (BottomNav에서 active 상태 판단용) */
export const MORE_PATHS = moreItems.map((m) => m.href);
